import React from 'react';
import { Star, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+2.000',
  label: 'docentes confían'
}, {
  value: '7',
  label: 'Tomos completamente organizados'
}, {
  value: '4.9/5',
  label: 'calificación',
  hasStar: true
}, {
  value: '🌎',
  label: 'Latinoamérica — secundaria'
}];
const testimonials = [{
  initials: 'MG',
  name: 'Mariela G.',
  location: 'Bogotá',
  specialty: 'Secundaria',
  quote: '"Organicé todo el año de Física en una tarde"',
  color: 'bg-blue-600'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Lima',
  specialty: 'Secundaria',
  quote: '"Mis clases de secundaria por fin enganchan a los alumnos"',
  color: 'bg-indigo-600'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Ciudad de México',
  specialty: 'Secundaria',
  quote: '"Nunca más tuve que improvisar una planificación"',
  color: 'bg-sky-600'
}];
export function SocialProof() {
  return <section className="pt-4 pb-6 md:py-20 px-4 max-w-7xl mx-auto" data-id="element-226">
      {/* Stats Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-8 md:mb-20" data-id="element-227">
        {stats.map((stat, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="text-center" data-id="element-228">
            <div className="flex items-center justify-center gap-1 mb-1 md:mb-2" data-id="element-229">
              <span className="text-3xl md:text-5xl font-black text-blue-600" data-id="element-230">
                {stat.value}
              </span>
              {stat.hasStar && <Star className="fill-blue-600 text-blue-600 w-4 h-4 md:w-6 md:h-6" data-id="element-231" />}
            </div>
            <p className="text-slate-600 font-bold text-[10px] md:text-base uppercase tracking-wide" data-id="element-232">
              {stat.label}
            </p>
          </motion.div>)}
      </div>

      {/* Testimonials Grid */}
      <div className="grid md:grid-cols-3 gap-4 md:gap-6" data-id="element-233">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1 + 0.4
      }} className="bg-white p-6 md:p-8 rounded-3xl shadow-xl shadow-blue-900/5 border border-blue-50 relative overflow-hidden group" data-id="element-234">
            <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-6" data-id="element-235">
              <div className={`${t.color} w-10 h-10 md:w-12 md:h-12 rounded-xl md:rounded-2xl flex items-center justify-center text-white font-black text-base md:text-lg shadow-lg`} data-id="element-236">
                {t.initials}
              </div>
              <div data-id="element-237">
                <div className="flex gap-0.5 mb-1" data-id="element-238">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-blue-600 text-blue-600" data-id="element-239" />)}
                </div>
                <p className="text-xs font-bold text-slate-400 uppercase tracking-tighter" data-id="element-240">
                  Verificado
                </p>
              </div>
            </div>

            <blockquote className="text-base md:text-lg font-bold text-slate-800 mb-4 md:mb-6 leading-tight" data-id="element-241">
              {t.quote}
            </blockquote>

            <div className="flex items-center justify-between pt-4 md:pt-6 border-t border-slate-50" data-id="element-242">
              <div className="text-xs md:text-sm" data-id="element-243">
                <p className="font-black text-slate-900" data-id="element-244">{t.name}</p>
                <div className="flex items-center gap-1 text-slate-500 font-medium" data-id="element-245">
                  <MapPin size={12} data-id="element-246" />
                  <span data-id="element-247">
                    {t.location} | {t.specialty}
                  </span>
                </div>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}